/**
 * JS for archives (is_archive())
 */
import { ComponentManager } from 'js-component-framework';

// Import components and manager here
import loadMoreConfig from '../components/LoadMore/loadMoreConfig';

// Create instance of the component manager using `wp-starter-theme`
const manager = new ComponentManager('prb-2017'); // eslint-disable-line no-unused-vars

// Initialize components here
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents([loadMoreConfig]);
});

// HMR Acceptance
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./client/js/archive/archive.js